var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg62(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.749902 9.82578C0.599902 9.82578 0.449902 9.77578 0.349902 9.65078C0.124902 9.42578 0.124902 9.07578 0.349902 8.85078L7.9249 1.27578H1.8749C1.5749 1.27578 1.3249 1.02578 1.3249 0.725781C1.3249 0.425781 1.5749 0.175781 1.8749 0.175781H9.2499C9.5499 0.175781 9.7999 0.425781 9.7999 0.725781V8.15078C9.7999 8.45078 9.5499 8.70078 9.2499 8.70078C8.9499 8.70078 8.6999 8.45078 8.6999 8.15078V2.12578L1.1499 9.67578C1.0499 9.77578 0.899902 9.82578 0.749902 9.82578Z",
    fill: "#0092CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg62);
export default __webpack_public_path__ + "static/media/svg62.48016dd503fc52213476c206a6ca2035.svg";
export { ForwardRef as ReactComponent };